import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { SupervisionUserEventsFilterFormValues } from './SupervisionHeader/types';

interface SupervisionUserEventsFilterContextContent {
  filter: Partial<SupervisionUserEventsFilterFormValues>;
  setFilter: Dispatch<
    SetStateAction<Partial<SupervisionUserEventsFilterFormValues>>
  >;
}

const SupervisionUserEventsFilterContext =
  createContext<SupervisionUserEventsFilterContextContent | null>(null);

export const useSupervisionUserEventsFilterContext = (): [
  Partial<SupervisionUserEventsFilterFormValues>,
  Dispatch<SetStateAction<Partial<SupervisionUserEventsFilterFormValues>>>,
] => {
  const context = useContext(SupervisionUserEventsFilterContext);
  if (context === null) {
    throw new Error('useFilterContext called outside Context.');
  }

  return [context.filter, context.setFilter];
};

const SupervisionUserEventsFilterProvider =
  SupervisionUserEventsFilterContext.Provider;

export default SupervisionUserEventsFilterProvider;
